module.exports = __webpack_public_path__ + "static/media/nonfood.9aee958f.pdf";